import { useEffect, useState, useCallback } from "react";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Switch } from "../../ui/switch";
import { Label } from "../../ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { v4 as uuidv4 } from "uuid";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../ui/table";

import {
  Search,
  Plus,
  Edit,
  Trash2,
  Download,
  Globe,
  ExternalLink,
  Shield,
  Key,
  User,
  Loader2,
} from "lucide-react";
import { useToast } from "../../../hooks/use-toast";
import { Role } from "../interfaces/CommonInterfaces";
import PublishComponent from "../PublishComponent";
import { myLocalStorage } from "../../StorageHelper";
import useUserStore from "../../../services/userStore";
import {
  createAuth,
  deleteURL,
  getWebUrls,
  getWebUrlsCount,
  publishURL,
  updateAuth,
  updateRecording,
} from "./Api/weburlapi";
import {
  Auth,
  WebUrlData,
  webURLLoadingState,
  WebUrlRecord,
} from "./interface";
import TenantLists from "../TenantLists";
import { getRolesList } from "../Endpoints/Api/EndpointApi";
import AddEditWebUrl from "./AddEditWebUrl";
import { useNavigate } from "react-router-dom";
import ConfirmationDialog from "../Endpoints/ConfirmationDialog";
import TenantWebUrlsTable from "../TenantWebURL/TenantWebUrlsTable";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../../ui/dialog";
import { NGROK } from "../../../APIs";
import axios from "axios";
import { FaApple, FaWindows } from "react-icons/fa6";
import { formatDate } from "../formatTimeAgo";
import binaryApi from "../../../utils/binaryApi";
import {
  LIST_STATE_KEYS,
  parsePersistedNumber,
  parsePersistedString,
  readPersistedListState,
  writePersistedListState,
  useSkipInitialPageReset,
} from "../../../utils/listPaginationState";
import EmptyStateCard from "../EmptyStateCard";
import { Skeleton } from "../../ui/skeleton";
import EndpointActionButton from "../Endpoints/EndpointActionButton";
import "./WebUrls.css";
import "../ManagementDialog.css";

const sortWebUrlsByIdDesc = (urls: WebUrlRecord[]) =>
  [...urls].sort((left, right) => right.id - left.id);

function resolveTenantName(
  latestTenant: unknown,
  selectedTenant?: string,
): string {
  if (selectedTenant?.trim()) {
    return selectedTenant.trim();
  }
  if (!latestTenant) {
    return "";
  }
  if (typeof latestTenant === "string") {
    return latestTenant;
  }
  if (
    typeof latestTenant === "object" &&
    latestTenant !== null &&
    "tenantName" in latestTenant
  ) {
    return String((latestTenant as { tenantName?: string }).tenantName || "");
  }
  return "";
}

export default function WebUrlsTable() {
  const savedListState = readPersistedListState(LIST_STATE_KEYS.webUrls);
  const { toast } = useToast();
  const [selectedTenant, setSelectedTenant] = useState(
    parsePersistedString(savedListState.selectedTenant, ""),
  );
  const [searchQuery, setSearchQuery] = useState(
    parsePersistedString(savedListState.searchQuery, ""),
  );
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [, setNewUrl] = useState("");
  const [, setNewDescription] = useState("");
  const tenantName = resolveTenantName(
    myLocalStorage.getItem("latestTenant"),
    selectedTenant,
  );
  const { role, email } = useUserStore(
    (state) => state.user,
  );
  const [, setLoadingRoles] = useState(true);
  const [selectedWebUrl, setSelectedWebUrl] = useState<WebUrlRecord>();
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [selectedAuth, setSelectedAuth] = useState<WebUrlRecord>();
  const [open, setOpen] = useState<boolean>(false);
  const [credentialsearch, setCredentialsearch] = useState<string>("");
  const [selectedCredential, setSelectedCredential] = useState<Auth>();
  const userData = useUserStore((state) => state.user);
  const [loadingWebUrlState, setLoadinWebUrlState] = useState<
    Record<string, webURLLoadingState>
  >({});
  const [loadingState, setLoadingState] = useState<Record<string, boolean>>({});

  let userAccess = userData.role;
  let loginemail = userData.email;

  const [roles, setRoles] = useState<Role[]>([]);
  const [mode, setMode] = useState<"add" | "edit">("add");

  const [webUrls, setWebUrls] = useState<WebUrlRecord[]>([]);
  const [page, setPage] = useState(
    parsePersistedNumber(savedListState.page, 1),
  );
  const [rowsPerPage] = useState(15);
  const [totalCount, setTotalCount] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState(
    parsePersistedString(savedListState.searchQuery, ""),
  );
  const [loadingUrls, setLoadingUrls] = useState(false);
  const navigate = useNavigate();
  const runTenantChangeWithPageReset = useSkipInitialPageReset(setPage);
  const access_token = myLocalStorage.getItem("access_token");

  const loginToUrl = async (selectedUser: Auth) => {
    let { authValutTags, email } = selectedUser;
    let randomUUID = uuidv4();
    let payload = {
      tokenpasskey: randomUUID,
      userTag: authValutTags,
      email: email,
      token: access_token,
      url: NGROK,
      executeURL: selectedAuth?.url,
      role: userAccess,
      duration: 0,
      tenantName: tenantName,
      webId: selectedAuth?.id,
      loginemail: loginemail,
      isRecordingOff: !selectedAuth?.recordingenabled,
    };
    const response = await axios
      .get(`${NGROK}/api/websites/save-web-url-click?uuid=${randomUUID}`)
      .then(async () => {
        await axios
          .post("http://localhost:5051/start-automation", payload)
          .then((data) => {})
          .catch((e) => {
            console.log("Error {}", e);
            const message = e?.response?.data?.message;
            if (selectedAuth) {
              setLoadinWebUrlState((prevState: any) => ({
                ...prevState,
                [selectedAuth.id]: {
                  loading: false,
                  message: "Connected",
                },
              }));
            }

            toast({
              title: "WSWebApp not running",
              description:
                message ||
                "WSWebApp not running... Make sure that the zip is downloaded and WSWebApp is running",
              variant: "destructive",
            });
          });
      })
      .catch((e) => {
        console.log("Error {}", e);
        const message = e?.response?.data?.message;
        if (selectedAuth) {
          setLoadinWebUrlState((prevState: any) => ({
            ...prevState,
            [selectedAuth.id]: {
              loading: false,
              message: "Connected",
            },
          }));
        }
        toast({
          title: "WSWebApp not running",
          description:
            message ||
            "WSWebApp not running... Make sure that the zip is downloaded and WSWebApp is running",
          variant: "destructive",
        });
      });

    setTimeout(() => {
      if (selectedAuth) {
        setLoadinWebUrlState((prevState: any) => ({
          ...prevState,
          [selectedAuth.id]: {
            loading: false,
            message: "Connected",
          },
        }));
      }
    }, 5000);
  };

  const handleWebURLClick = (url: WebUrlRecord) => {
    try {
      if (url) {
        persistListState();
        localStorage.setItem("selectedWebUrl", url.url);
        navigate(`/webUrls/webUrldetails/${url.id}`);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getFaviconUrl = (url: string) => {
    try {
      const domain = new URL(url).hostname;
      return `https://www.google.com/s2/favicons?sz=64&domain=${domain}`;
    } catch {
      return undefined;
    }
  };

  const totalPages = Math.max(1, Math.ceil(totalCount / rowsPerPage));

  const fetchWebURLs = useCallback(
    async (
      tenant: string,
      currentPage = page,
      search = debouncedSearch,
      options: { silent?: boolean } = {},
    ) => {
      if (!tenant.trim()) {
        setWebUrls([]);
        setTotalCount(0);
        return;
      }

      if (!options.silent) {
        setLoadingUrls(true);
      }
      try {
        const response = await getWebUrls(
          tenant,
          email,
          currentPage,
          rowsPerPage,
          search,
        );
        let count = response.length;
        try {
          count = await getWebUrlsCount(tenant, email, search);
        } catch (countError) {
          console.error("Failed to fetch web URL count", countError);
        }
        setWebUrls(
          sortWebUrlsByIdDesc(Array.isArray(response) ? response : []),
        );
        setTotalCount(count);
      } catch (error) {
        console.error("Failed to fetch web URLs", error);
        setWebUrls([]);
        setTotalCount(0);
      } finally {
        if (!options.silent) {
          setLoadingUrls(false);
        }
      }
    },
    [email, rowsPerPage, page, debouncedSearch],
  );

  const persistListState = useCallback(
    (nextPage = page) => {
      writePersistedListState(LIST_STATE_KEYS.webUrls, {
        page: nextPage,
        searchQuery,
        selectedTenant,
      });
    },
    [page, searchQuery, selectedTenant],
  );

  const filteredCredentials = selectedAuth?.auth.filter((search) =>
    search.email.toLowerCase().includes(credentialsearch.toLowerCase()),
  );

  const handlePublish = async (urlId: number, selectedRoles: string[]) => {
    setWebUrls((prev) =>
      prev.map((url) =>
        url.id === urlId ? { ...url, publishedroleIds: selectedRoles } : url,
      ),
    );
    let response = await publishURL(tenantName, urlId, selectedRoles);
    toast({
      title: "URL Published",
      description:
        selectedRoles.length > 0
          ? `URL published to ${selectedRoles.length} role(s)`
          : "Unpublished from all roles",
    });
    if (response) fetchWebURLs(tenantName, page, debouncedSearch);
  };

  const handleRecordingChange = async (urlId: number, recording: boolean) => {
    setWebUrls((prev) =>
      prev.map((url) =>
        url.id === urlId ? { ...url, recordingenabled: recording } : url,
      ),
    );
    let response = await updateRecording(tenantName, urlId);
    toast({
      title: recording ? "Recording Enabled" : "Recording Disabled",
      description: `Recording has been ${recording ? "enabled" : "disabled"} for this URL`,
    });
    if (response) fetchWebURLs(tenantName, page, debouncedSearch);
  };

  const handleConnect = (url: WebUrlRecord) => {
    setSelectedAuth(url);
    setOpen(true);
  };

  const handleAddUrl = async (payload: WebUrlData) => {
    if (!payload.url.trim()) {
      toast({
        title: "Error",
        description: "URL is required",
        variant: "destructive",
      });
      return;
    }

    const domain = payload.url;

    let data = {
      url: domain,
      tenantName: tenantName,
      isManaged: false,
      auth: payload.credentials,
    };
    try {
      await createAuth(data);
      setNewUrl("");
      setNewDescription("");
      setIsAddDialogOpen(false);
      setPage(1);

      toast({
        title: "URL Added",
        description: `${domain} has been added successfully`,
      });
      fetchWebURLs(tenantName, 1);
    } catch (error: any) {
      toast({
        title: "Error",
        description:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to add URL",
        variant: "destructive",
      });
    }
  };

  const handleEdit = async (payload: any) => {
    await updateAuth(payload, tenantName);
    setIsAddDialogOpen(false);
    toast({
      title: "Edit URL",
      description:
        payload.url.length > 0 ? `Edited for ${payload.url}` : "Edited Web URL",
    });
    fetchWebURLs(tenantName, page, debouncedSearch);
  };

  const handleDelete = async (urlId: number) => {
    await deleteURL(urlId);

    const url = webUrls.find((u) => u.id === urlId);
    const nextPage = webUrls.length === 1 && page > 1 ? page - 1 : page;
    if (nextPage !== page) {
      setPage(nextPage);
    }
    toast({
      title: "URL Deleted",
      description: `${url?.url} has been deleted successfully`,
    });
    fetchWebURLs(tenantName, nextPage);
  };

  const handleDownloadZip = async (type: string) => {
    toast({
      title: "Download Started",
      description: `Downloading ${type} zip file...`,
    });

    try {
      setLoadingState((prev: any) => ({
        ...prev,
        [type]: true,
      }));

      const response = await binaryApi.get(
        `${NGROK}/api/websites/download?os=${type}`,
        {
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const percent = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
              console.log(`Progress: ${percent}%`);
            }
          },
        },
      );

      const blob = new Blob([response.data], { type: "application/zip" });

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "WSWebApp.zip";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed", err);
      toast({
        title: "Download Failed",
        description: "Unable to download the file",
        variant: "destructive",
      });
    } finally {
      setLoadingState((prev: any) => ({
        ...prev,
        [type]: false,
      }));
    }
  };

  const getRoles = async () => {
    setLoadingRoles(true);
    try {
      const response = await getRolesList(tenantName);
      if (response && response.length > 0) {
        const formattedRoles: Role[] = response
          .map((role: { id: number; roleName: string }) => ({
            id: String(role.id),
            name: role.roleName,
          }))
          .filter(
            (role: Role) =>
              role.name !== "super-user" && role.name !== "unassigned-user",
          );

        setRoles(formattedRoles);
      } else {
        setRoles([]);
      }
    } finally {
      setLoadingRoles(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchQuery), 300);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    writePersistedListState(LIST_STATE_KEYS.webUrls, {
      page,
      searchQuery,
      selectedTenant,
    });
  }, [page, searchQuery, selectedTenant]);

  useEffect(() => {
    if (role !== "TENANT_USER") {
      getRoles();
    }
    fetchWebURLs(tenantName, page, debouncedSearch);
  }, [
    tenantName,
    email,
    page,
    debouncedSearch,
    selectedTenant,
    fetchWebURLs,
    role,
  ]);

  return (
    <div className="web-urls-page">
      <div className="web-urls-toolbar">
        <div className="web-urls-controls">
          <TenantLists
            onSelectorChange={(tenant: string) => {
              runTenantChangeWithPageReset(() => setSelectedTenant(tenant));
            }}
            isLabelNeeded
            variant="card"
          />
          <div className="web-urls-search">
            <Label htmlFor="web-url-search">
              <Search aria-hidden="true" /> Search
            </Label>
            <div className="web-urls-search-input">
              <Search aria-hidden="true" />
              <Input
                id="web-url-search"
                placeholder="Search URLs by domain or name..."
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setPage(1);
                }}
                data-testid="input-search"
              />
            </div>
          </div>
        </div>
        <div className="web-urls-actions">
          <span className="web-urls-count">
            {totalCount} {totalCount === 1 ? "URL" : "URLs"} found
          </span>
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleDownloadZip("mac")}
            data-testid="button-download-webapp"
            disabled={loadingState["mac"] || false}
          >
            <FaApple className="w-4 h-4" /> Download Zip
            {loadingState["mac"] && (
              <Loader2 className="w-4 h-4 animate-spin" />
            )}
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleDownloadZip("windows")}
            data-testid="button-download-extension"
            disabled={loadingState["windows"] || false}
          >
            <FaWindows className="w-4 h-4" /> Download Zip
            {loadingState["windows"] && (
              <Loader2 className="w-4 h-4 animate-spin" />
            )}
          </Button>
          {role !== "TENANT_USER" && (
            <EndpointActionButton
              onClick={() => {
                setMode("add");
                setIsAddDialogOpen(true);
              }}
              data-testid="button-add-url"
            >
              <Plus className="w-4 h-4" /> Add New URL
            </EndpointActionButton>
          )}
        </div>
        <div className="web-urls-setup">
          <span className="web-urls-icon">
            <Download aria-hidden="true" />
          </span>
          <div>
            <strong>Setup instructions</strong>
            <p>
              Install the downloaded zip and run WSWebApp on the machines that
              will access these URLs. This enables secure credential management
              and session handling.
            </p>
          </div>
        </div>
      </div>
      <Card className="web-urls-panel">
        <CardHeader className="web-urls-panel-header">
          <span className="web-urls-icon">
            <Globe aria-hidden="true" />
          </span>
          <div>
            <CardTitle>Web applications</CardTitle>
            <p>Manage credentials, published roles, and recorded access</p>
          </div>
        </CardHeader>
        {role === "TENANT_USER" ? (
          loadingUrls && webUrls.length === 0 ? (
            <CardContent
              className="web-urls-loading"
              role="status"
              aria-label="Loading web URLs"
            >
              {Array.from({ length: 5 }).map((_, index) => (
                <div key={index} className="web-urls-loading-row">
                  <Skeleton className="web-urls-loading-icon" />
                  <div>
                    <Skeleton className="h-4 w-3/4" />
                    <Skeleton className="h-3 w-1/2 mt-3" />
                  </div>
                  <Skeleton className="h-9 w-24" />
                </div>
              ))}
            </CardContent>
          ) : (
            <TenantWebUrlsTable
              webUrls={webUrls}
              totalCount={totalCount}
              onConnect={() => {}}
              refetchWebUrls={() =>
                fetchWebURLs(tenantName, page, debouncedSearch, {
                  silent: true,
                })
              }
              searchQuery={searchQuery}
            />
          )
        ) : (
          <CardContent className="web-urls-table-wrap">
            {!loadingUrls && webUrls.length === 0 ? (
              <div className="p-6">
                <EmptyStateCard
                  icon={Globe}
                  title={
                    searchQuery
                      ? "No URLs match your search criteria"
                      : "No web URLs have been configured"
                  }
                  description={
                    searchQuery
                      ? "Try adjusting your search terms or add a new URL."
                      : "Start by adding your first web application URL to enable secure access management."
                  }
                  action={
                    !searchQuery ? (
                      <Button
                        onClick={() => setIsAddDialogOpen(true)}
                        className="gap-1.5"
                        size="sm"
                      >
                        <Plus className="w-4 h-4" />
                        Add Your First URL
                      </Button>
                    ) : undefined
                  }
                />
              </div>
            ) : (
              <div className="rounded-b-lg overflow-hidden">
                <Table>
                  <TableHeader>
                    <TableRow className="bg-slate-800 hover:bg-slate-800 dark:bg-slate-900 dark:hover:bg-slate-900 border-0">
                      <TableHead className="text-white font-bold text-sm py-3 px-4">
                        Web Application
                      </TableHead>
                      <TableHead className="text-white font-bold text-sm py-3 px-4">
                        Role Management
                      </TableHead>
                      <TableHead className="text-white font-bold text-sm py-3 px-4 text-center">
                        Recording
                      </TableHead>
                      <TableHead className="text-white font-bold text-sm py-3 px-4 text-center">
                        Access
                      </TableHead>
                      <TableHead className="text-white font-bold text-sm py-3 px-4 text-center">
                        Actions
                      </TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {loadingUrls
                      ? Array.from({ length: 5 }).map((_, index) => (
                          <TableRow key={index} aria-label="Loading web URL">
                            <TableCell>
                              <div className="flex items-center gap-3">
                                <Skeleton className="web-urls-loading-icon" />
                                <div className="flex-1">
                                  <Skeleton className="h-4 w-3/4" />
                                  <Skeleton className="h-3 w-1/2 mt-3" />
                                </div>
                              </div>
                            </TableCell>
                            {Array.from({ length: 4 }).map((__, column) => (
                              <TableCell key={column}>
                                <Skeleton className="h-8 w-20 mx-auto" />
                              </TableCell>
                            ))}
                          </TableRow>
                        ))
                      : webUrls.map((url) => (
                          <TableRow
                            key={url.id}
                            className="hover:bg-slate-50 dark:hover:bg-slate-800/50 border-b transition-colors"
                            data-testid={`row-url-${url.id}`}
                          >
                            <TableCell className="py-3 px-4 ">
                              <div className="flex items-center gap-3">
                                <div className="web-urls-icon">
                                  {getFaviconUrl(url.url) ? (
                                    <img
                                      src={getFaviconUrl(url.url)}
                                      alt="favicon"
                                      className="w-6 h-6 object-contain"
                                    />
                                  ) : (
                                    <Globe className="w-6 h-6 text-blue-600" />
                                  )}
                                </div>
                                <div className="flex-1">
                                  <button
                                    type="button"
                                    className="web-url-name"
                                    onClick={() => handleWebURLClick(url)}
                                  >
                                    {url.url}
                                  </button>
                                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-1 text-xs text-muted-foreground">
                                    <div>Created: {formatDate(url.date)}</div>
                                    <div>By: {url.createdBy}</div>
                                    <div className="sm:col-span-2">
                                      Credentials: {url.auth.length || 0}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </TableCell>

                            <TableCell className="py-3 px-4">
                              <div className="space-y-2">
                                <PublishComponent
                                  entityName={url.url}
                                  entityType="url"
                                  cardStyle
                                  availableRoles={roles}
                                  publishedRoles={url.publishedroleIds || []}
                                  onPublish={(selectedRoles) =>
                                    handlePublish(url.id, selectedRoles)
                                  }
                                  buttonVariant="outline"
                                  buttonSize="sm"
                                />
                              </div>
                            </TableCell>

                            <TableCell className="py-3 px-4">
                              <div className="flex items-center justify-center">
                                <Switch
                                  checked={url.recordingenabled}
                                  onCheckedChange={(checked) =>
                                    handleRecordingChange(url.id, checked)
                                  }
                                  data-testid={`switch-recording-${url.id}`}
                                  className="web-url-recording"
                                  aria-label={`Record sessions for ${url.url}`}
                                />
                              </div>
                            </TableCell>

                            <TableCell className="py-3 px-4">
                              <div className="flex justify-center">
                                <Button
                                  disabled={loadingWebUrlState[url.id]?.loading}
                                  size="sm"
                                  onClick={() => handleConnect(url)}
                                  className="web-url-primary gap-1.5 px-3"
                                  data-testid={`button-connect-${url.id}`}
                                >
                                  <ExternalLink className="w-4 h-4" />
                                  Connect
                                  {loadingWebUrlState[url.id]?.loading && (
                                    <Loader2 className="w-4 h-4 text-white-600 dark:text-white-400 animate-spin" />
                                  )}
                                </Button>
                              </div>
                            </TableCell>

                            <TableCell className="py-3 px-4">
                              <div className="flex items-center justify-center gap-2">
                                <Button
                                  variant="outline"
                                  size="sm"
                                  onClick={() => {
                                    setMode("edit");
                                    setSelectedWebUrl(url);
                                    setIsAddDialogOpen(true);
                                  }}
                                  className="gap-1.5 text-blue-600 hover:text-blue-700 border-blue-200 hover:border-blue-300 px-2 h-8"
                                  data-testid={`button-edit-${url.id}`}
                                >
                                  <Edit className="w-4 h-4" />
                                  Edit
                                </Button>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  onClick={() => {
                                    setSelectedWebUrl(url);
                                    setShowDeleteConfirmation(true);
                                  }}
                                  className="gap-1.5 text-red-600 hover:text-red-700 border-red-200 hover:border-red-300 px-2 h-8"
                                  data-testid={`button-delete-${url.id}`}
                                >
                                  <Trash2 className="w-4 h-4" />
                                  Delete
                                </Button>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              </div>
            )}
          </CardContent>
        )}

        {totalPages > 1 && (
          <div className="web-urls-pagination">
            <div className="text-sm text-muted-foreground">
              Showing {(page - 1) * rowsPerPage + 1}–
              {Math.min(page * rowsPerPage, totalCount)} of {totalCount}
            </div>
            <div className="flex items-center space-x-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => setPage(page - 1)}
                disabled={page === 1}
                data-testid="button-prev-page-weburls"
              >
                Previous
              </Button>
              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                const startPage = Math.max(
                  1,
                  Math.min(page - 2, totalPages - 4),
                );
                const pageNum = startPage + i;
                if (pageNum > totalPages) return null;
                return (
                  <Button
                    key={pageNum}
                    variant={pageNum === page ? "default" : "outline"}
                    size="sm"
                    onClick={() => setPage(pageNum)}
                    data-testid={`page-weburls-${pageNum}`}
                  >
                    {pageNum}
                  </Button>
                );
              })}
              <Button
                variant="outline"
                size="sm"
                onClick={() => setPage(page + 1)}
                disabled={page >= totalPages}
                data-testid="button-next-page-weburls"
              >
                Next
              </Button>
            </div>
          </div>
        )}
      </Card>

      <AddEditWebUrl
        open={isAddDialogOpen}
        onOpenChange={setIsAddDialogOpen}
        mode={mode}
        onSave={(payload) => handleAddUrl(payload)}
        onEdit={(payload) => handleEdit(payload)}
        webUrl={selectedWebUrl && selectedWebUrl}
      />

      <ConfirmationDialog
        open={showDeleteConfirmation}
        onOpenChange={setShowDeleteConfirmation}
        className="management-dialog management-confirmation"
        title="Delete Web URL"
        description={`Are you sure, you want to delete this url - ${selectedWebUrl?.url}?`}
        confirmText="Delete"
        cancelText="Cancel"
        variant="destructive"
        onConfirm={() => {
          if (selectedWebUrl) handleDelete(selectedWebUrl?.id);
        }}
      />

      <Dialog open={open} onOpenChange={() => setOpen(false)} modal={true}>
        <DialogContent className="management-dialog web-url-connect-dialog">
          <DialogHeader className="management-dialog-header">
            <div className="management-dialog-heading">
              <div className="management-dialog-icon">
                <Key className="w-5 h-5 text-blue-600 dark:text-blue-400" />
              </div>
              <div>
                <DialogTitle className="text-xl font-semibold">
                  Select Credentials
                </DialogTitle>
                <DialogDescription>
                  Choose credentials for{" "}
                  <span className="web-url-dialog-target">
                    {selectedAuth?.url}
                  </span>
                </DialogDescription>
              </div>
            </div>
          </DialogHeader>

          <div className="management-dialog-body web-url-credential-body">
            {}
            <Card>
              <CardContent className="pt-6">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                  <Input
                    placeholder="Search credentials by name, type, or description..."
                    value={credentialsearch}
                    onChange={(e) => setCredentialsearch(e.target.value)}
                    className="pl-10 text-sm"
                    data-testid="input-credential-search"
                  />
                </div>
              </CardContent>
            </Card>

            {}
            <Card>
              <CardHeader>
                <CardTitle className="text-lg flex items-center gap-2">
                  <Shield className="w-5 h-5" />
                  Available Credentials ({selectedAuth?.auth.length || 0})
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-3 max-h-80 overflow-y-auto">
                  {filteredCredentials?.map((credential) => (
                    <div
                      key={credential.id}
                      className="web-url-credential-choice"
                      data-selected={selectedCredential?.id === credential.id}
                      onClick={() => setSelectedCredential(credential)}
                      data-testid={`credential-${credential.id}`}
                    >
                      {}
                      <div
                        className={`w-1 rounded-l-lg ${
                          selectedCredential?.id === credential.id
                            ? "bg-blue-500"
                            : "bg-transparent"
                        }`}
                      ></div>

                      <div className="p-4 flex-1">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 flex items-center justify-center ">
                              <User className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                            </div>
                            <div>
                              <div className="font-medium text-sm">
                                {credential.email}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {filteredCredentials?.length === 0 && (
                  <div className="text-center py-8">
                    <Search className="w-8 h-8 text-muted-foreground mx-auto mb-3" />
                    <p className="text-sm text-muted-foreground">
                      No credentials found matching your search.
                    </p>
                    <p className="text-xs text-muted-foreground mt-1">
                      Try adjusting your search criteria.
                    </p>
                  </div>
                )}
              </CardContent>
            </Card>

            {}
          </div>
          <div className="management-dialog-footer">
            <Button
              variant="outline"
              onClick={() => setOpen(false)}
              data-testid="button-cancel"
              className="px-6"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                if (selectedCredential) loginToUrl(selectedCredential);
                setOpen(false);
                setLoadinWebUrlState((prevState: any) => ({
                  ...prevState,
                  [selectedAuth?.id ?? ""]: {
                    loading: true,
                    message: "Connecting... Please wait.",
                  },
                }));
              }}
              disabled={!selectedCredential}
              data-testid="button-submit"
              className="web-url-primary px-6"
            >
              Connect
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
